import React from 'react';
import { mapLocaleToMeaningfulFormat } from '@/helpers/utils/i18n';
import ExcludedBrandTooltip from '../../../../../components/customercenter-ui/tooltip/excludedBrand';

const PromotionNotAllow = ({ excludedBrandsContent }: any) => {
  return (
    <div className="w-full py-2">
      <p className="inline text-[15px] font-semibold leading-[21px] text-scarletRed">
        {mapLocaleToMeaningfulFormat().promotionNotAllowText}{' '}
        <ExcludedBrandTooltip
          excludedBrandsContent={excludedBrandsContent}
          showRedIcon={true}
          className="inline h-5 w-5 shrink-0 fill-scarletRed"
        />
      </p>
    </div>
  );
};

export default PromotionNotAllow;
